export default "__VITE_ASSET__8df22277__"